export default __webpack_public_path__ + "static/media/rain-on-roof.781b9a24.mp3";